import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=850ca5f2"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports